import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import renderTextareaInputField from 'components/form/InputFields/RenderTextareaInputField';
import { voucherFailure, voucherSuccess } from 'store/actions/orderActions';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import { AlertIcon } from 'assets/materialIcons/materialIcons';
import theme from 'theme/theme';
import Dialog from 'components/ui/dialog/Dialog';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';

class UpdateVoucherForm extends Component {
    state = {
        isLoading: false,
    };

    componentDidMount() {
        const { initialize } = this.props;

        const initialValues = {
            updated: false,
            text: '',
        };

        initialize(initialValues);
    }

    sendVoucherRequest = (data = {}) => {
        const { id, voucherFailure, voucherSuccess, toggleVoucherModal } = this.props;

        this.setState({
            isLoading: true,
        });

        const url = `${ config.getApiBaseUrl() }/bookings/${ id }/voucher/send`;

        return apiClient.create(url, data).then(() => {
            this.setState({
                isLoading: false,
            });

            toggleVoucherModal();

            return voucherSuccess('resources.orders.voucher.send.success');
        }, (error) => {
            this.setState({
                isLoading: false,
            });

            toggleVoucherModal();
            return voucherFailure(error);
        });
    }

    sendVoucher = (data) => {
        if (data.updated) {
            return this.sendVoucherRequest(data);
        }

        this.sendVoucherRequest();
    }

    render() {
        const {
            handleSubmit,
            toggleVoucherModal,
            translate,
        } = this.props;

        const { isLoading } = this.state;

        const actions = [
            <EnhancedRaisedButton
                key='cancel'
                keyboardFocused={ true }
                label={ translate('actions.goBack') }
                onTouchTap={ toggleVoucherModal }
                style={ { marginRight: '20px' } }
            />,
            <EnhancedRaisedButton
                backgroundColor={ theme.palette.redOrange }
                icon={ <AlertIcon /> }
                key='submit'
                label={ translate('resources.orders.voucher.send.title') }
                labelColor={ theme.palette.white }
                disabled={ isLoading }
                loading={ isLoading }
                onClick={ handleSubmit(this.sendVoucher) }
                type='submit'
            />,
        ];

        return (
            <Dialog
                actions={ actions }
                actionsContainerStyle={ { padding: '0 24px 24px' } }
                contentStyle={ { maxWidth: '400px' } }
                overlayStyle={ {
                    backgroundColor: 'rgba(237, 236, 236, 0.6)',
                } }
                onRequestClose={ toggleVoucherModal }
                open={ true }
                title={ translate('resources.orders.voucher.send.title') }
            >
                <FormWrapper>
                    <form>
                        <Section>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderBooleanInputField }
                                        fullWidth={ false }
                                        label={ translate('fields.updated') }
                                        name='updated'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ renderTextareaInputField }
                                        maxLength={ 255 }
                                        multiLine={ true }
                                        rows={ 4 }
                                        label={ translate('fields.reason') }
                                        name='text'
                                    />
                                </Item>
                            </Row>
                        </Section>
                    </form>
                </FormWrapper>
            </Dialog>
        );
    }
}

UpdateVoucherForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    initialize: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    toggleVoucherModal: PropTypes.func.isRequired,
    voucherFailure: PropTypes.func.isRequired,
    voucherSuccess: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    connect(
        null,
        {
            voucherFailure: voucherFailure,
            voucherSuccess: voucherSuccess,
        }
    ),
    reduxForm({
        form: 'updateVoucherForm',
        validate: (values, props) => {
            const errors = {};

            if (!values.text && values.updated) {
                errors.text = props.translate('forms.required');
            }
            return errors;
        },
    }),
);

export default enhance(UpdateVoucherForm);


// WEBPACK FOOTER //
// ./src/components/button/Voucher/UpdateVoucherFormModal.js